import TableCOA from '../../../components/TableCOA';
import { getReportCOA } from '../../../axios/ReportAxios';
import { useEffect, useRef, useState } from 'react';
import Breadcrumb from '../../../components/Breadcrumb';
import html2pdf from 'html2pdf.js';
import './coaReport.css';
import {
  getAccountDropdown,
  getBusinessUnitDropdown,
  getExternalDropdown,
  getInternalDropdown,
  getProjectDropdown,
} from '../../../axios/MenuDropdownAxios';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import id from 'date-fns/locale/id'; // Untuk locale Indonesia (opsional)
registerLocale('id', id);

const CoaReport = () => {
  const breadcrumbItems = [
    { label: 'Dashboard', href: '/' },
    { label: 'Report Chart of Account' },
  ];

  const [reportCOA, setReportCOA] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  const [dropdownBunits, setDropdownBunits] = useState([]);
  const [dropdownExternal, setDropdownExternal] = useState([]);
  const [dropdownProject, setDropdownProject] = useState([]);
  const [dropdownInternal, setDropdownInternal] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    bulan: '',
    tahun: '',
    kodeCOA: '',
    kodeInt: '',
    kodeExt: '',
    kodePro: '',
    kodeBuNit: '',
  });

  const reportRef = useRef();

  const [selectedYear, setSelectedYear] = useState(null);

  const fetchReportCOA = async () => {
    try {
      const result = await getReportCOA(
        filters.bulan,
        filters.tahun,
        filters.kodeCOA,
        filters.kodeInt,
        filters.kodeExt,
        filters.kodePro,
        filters.kodeBuNit
      );
      setReportCOA(result || []);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDropdownData = async () => {
    try {
      const data = await getAccountDropdown(); // Panggil fungsi Axios
      setDropdownData(data);
    } catch (error) {
      console.error('Error fetching dropdown data account', error);
    }
  };

  const fetchDropdownBunits = async () => {
    try {
      const data = await getBusinessUnitDropdown();
      setDropdownBunits(data);
    } catch (error) {
      console.error('Error fetching dropdown data business unit', error);
    }
  };

  const fetchDropdownExternal = async () => {
    try {
      const data = await getExternalDropdown();
      setDropdownExternal(data);
    } catch (error) {
      console.error('Error fetching dropdown data external', error);
    }
  };

  const fetchDropdownInternal = async () => {
    try {
      const data = await getInternalDropdown();
      setDropdownInternal(data);
    } catch (error) {
      console.error('Error fetching dropdown data internal', error);
    }
  };

  const fetchDropdownProject = async () => {
    try {
      const data = await getProjectDropdown();
      setDropdownProject(data);
    } catch (error) {
      console.error('Error fetching dropdown data project', error);
    }
  };

  useEffect(() => {
    fetchDropdownData();
    fetchDropdownBunits();
    fetchDropdownExternal();
    fetchDropdownInternal();
    fetchDropdownProject();
    fetchReportCOA();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDownloadPDF = () => {
    const element = reportRef.current;
    const opt = {
      margin: 0.3,
      filename: `COA_Report_${new Date().toISOString().split('T')[0]}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
    };
    html2pdf()
      .set(opt)
      .from(element)
      .toPdf()
      .get('pdf')
      .then(function (pdf) {
        const totalPages = pdf.internal.getNumberOfPages();
        // Bisa juga log jumlah halaman jika mau
        console.log(totalPages);
      })
      .save();
  };

  return (
    <div>
      <Breadcrumb items={breadcrumbItems}></Breadcrumb>
      {/* 🔍 Filter Card */}
      <div className="card border shadow-sm filterCOA">
        <div className="card-body">
          <form
            className="row g-3"
            onSubmit={(e) => {
              e.preventDefault();
              fetchReportCOA(); // tetap manual jika ingin trigger pakai tombol
            }}
          >
            {/* 🔹 Baris Pertama - 4 Form Field */}
            <div className="col-md-3">
              <label className="form-label fw-bold">Account</label>
              <select
                className="form-select"
                value={filters.kodeCOA}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    kodeCOA: e.target.value,
                  }))
                }
              >
                <option value="">Pilih Kode COA</option>
                {dropdownData.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">Internal</label>
              <select
                className="form-select"
                value={filters.kodeInt}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    kodeInt: e.target.value,
                  }))
                }
              >
                <option value="">Pilih Kode Internal</option>
                {dropdownInternal.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">External</label>
              <select
                className="form-select"
                value={filters.kodeExt}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    kodeExt: e.target.value,
                  }))
                }
              >
                <option value="">Pilih Kode External</option>
                {dropdownExternal.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">Project</label>
              <select
                className="form-select"
                value={filters.kodePro}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    kodePro: e.target.value,
                  }))
                }
              >
                <option value="">Pilih Kode Project</option>
                {dropdownProject.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>

            {/* 🔹 Baris Kedua - 3 Field + 1 Button */}
            <div className="col-md-3">
              <label className="form-label fw-bold">Business Unit</label>
              <select
                className="form-select"
                value={filters.kodeBuNit}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    kodeBuNit: e.target.value,
                  }))
                }
              >
                <option value="">Pilih Kode Business Unit</option>
                {dropdownBunits.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">Bulan</label>
              <select
                className="form-select"
                value={filters.bulan}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    bulan: e.target.value,
                  }))
                }
              >
                <option value="">Pilih bulan</option>
                <option value="1">Januari</option>
                <option value="2">Februari</option>
                <option value="3">Maret</option>
                <option value="4">April</option>
                <option value="5">Mei</option>
                <option value="6">Juni</option>
                <option value="7">Juli</option>
                <option value="8">Agustus</option>
                <option value="9">September</option>
                <option value="10">Oktober</option>
                <option value="11">November</option>
                <option value="12">Desember</option>
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">Tahun</label>
              <div>
                <DatePicker
                  selected={selectedYear}
                  onChange={(date) => {
                    setSelectedYear(date);
                    setFilters((prev) => ({
                      ...prev,
                      tahun: date?.getFullYear(),
                    }));
                  }}
                  showYearPicker
                  dateFormat="yyyy"
                  className="form-control"
                  locale="id"
                  placeholderText="Pilih tahun"
                  wrapperClassName="w-100"
                />
              </div>
            </div>
            <div className="col-md-3 d-flex align-items-end">
              <button type="submit" className="btn btn-primary w-100">
                Filter
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          {/* 🔻 Tombol PDF dan Tabel */}
          <div className="d-flex justify-content-end align-items-center mb-3">
            <button
              className="btn btn-sm btn-primary"
              onClick={handleDownloadPDF}
            >
              Download PDF
            </button>
          </div>

          {/* 🔁 Data Table */}
          <div ref={reportRef}>
            {isLoading ? (
              <p>Loading...</p>
            ) : (
              reportCOA.map((group, idx) => (
                <TableCOA key={idx} group={group} />
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoaReport;
